import React, { FC } from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Tippy defautl styling

interface Props {
  content: JSX.Element;
  trigger: JSX.Element;
}

const Tooltip: FC<Props> = ({ content, trigger }) => {
  return (
    <Tippy
      appendTo="parent" // Prevent overflowing viewport
      className="membership-app__tooltip"
      content={content}
    >
      {trigger}
    </Tippy>
  );
};

export default Tooltip;
